export const RESET_DATA = "RESET_DATA";
